import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './fotos-albert-woltjes.css'

const FotosAlbertWoltjes = (props) => {
  return (
    <div className="fotos-albert-woltjes-container10">
      <Helmet>
        <title>Fotos-Albert-Woltjes - Schrijf je vrij</title>
        <meta
          property="og:title"
          content="Fotos-Albert-Woltjes - Schrijf je vrij"
        />
      </Helmet>
      <div className="fotos-albert-woltjes-top-container">
        <NavbarInteractive rootClassName="navbar-interactiveroot-class-name29"></NavbarInteractive>
      </div>
      <div id="main-section" className="fotos-albert-woltjes-main">
        <div
          data-thq="slider"
          data-navigation="true"
          data-pagination="false"
          className="fotos-albert-woltjes-slider swiper"
        >
          <div
            data-thq="slider-wrapper"
            className="fotos-albert-woltjes-hie-rslider-wrapper swiper-wrapper"
          >
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-hj-pas swiper-slide"
            >
              <div className="fotos-albert-woltjes-container11">
                <img
                  alt="image"
                  src="/Albert Woltjes/a1%20hj-pas-800w.jpg"
                  className="fotos-albert-woltjes-image10"
                />
                <span className="fotos-albert-woltjes-text10">
                  Albert Woltjes wordt lid van de Hitler-Jugend. Dit is zijn
                  Mitgliedsausweis (lidmaatschapspas).
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-bakkerij swiper-slide"
            >
              <div className="fotos-albert-woltjes-container12">
                <img
                  alt="image"
                  src="/Albert Woltjes/a2%20bakkerij-800w.jpg"
                  className="fotos-albert-woltjes-image11"
                />
                <span className="fotos-albert-woltjes-text11">
                  De woning waar Albert opgroeide met beneden de winkel en
                  rechts de bakkerij. Deze foto is van na de oorlog. Ervoor
                  heette het nog Dampfbäckerei G.F. Woltjes.
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-propaganda swiper-slide"
            >
              <div className="fotos-albert-woltjes-container13">
                <img
                  alt="image"
                  src="/Albert Woltjes/a3%20plakboek-800w.jpg"
                  className="fotos-albert-woltjes-image12"
                />
                <span className="fotos-albert-woltjes-text12">
                  De propagandamachine werkte goed. Hier zie je de voorkant en
                  een van de binnenpagina&apos;s van het door Albert netjes
                  bijgehouden plakboek.
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-pimpf-tijdschrift swiper-slide"
            >
              <div className="fotos-albert-woltjes-container14">
                <img
                  alt="image"
                  src="/Albert Woltjes/a4%20pimpf-800w.jpg"
                  className="fotos-albert-woltjes-image13"
                />
                <span className="fotos-albert-woltjes-text13">
                  Op de eerste foto het handboek voor het Jungvolk (de
                  Hitlerjugend van 10-14 jaar): &quot;Pimpf im Dienst&quot;.
                  Verder drie tijdschriften van &quot;Der Pimpf&quot;.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-leistungsbuch swiper-slide"
            >
              <div className="fotos-albert-woltjes-container15">
                <img
                  alt="image"
                  src="/Albert Woltjes/a5%20leistungsbuch%20hj-800w.jpg"
                  className="fotos-albert-woltjes-image14"
                />
                <span className="fotos-albert-woltjes-text14">
                  Twee pagina&apos;s uit het Leistungsbuch, waarin de prestaties
                  van een 13-jarige nauwkeurig werden bijgehouden. Je moest alle
                  onderdelen halen voordat je over mocht van het Jungvolk (10
                  tot 14 jaar) naar de Hitlerjugend (14 - 18 jaar).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-bakkersleerling swiper-slide"
            >
              <div className="fotos-albert-woltjes-container16">
                <img
                  alt="image"
                  src="/Albert Woltjes/a6%20bakkersdiploma-800w.jpg"
                  className="fotos-albert-woltjes-image15"
                />
                <span className="fotos-albert-woltjes-text15">
                  Na drie jaar in de leer te zijn geweest bij een  bakker
                  ontvangt Albert in maart 1942 zijn bakkersdiploma.  
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-rad swiper-slide"
            >
              <div className="fotos-albert-woltjes-container17">
                <img
                  alt="image"
                  src="/Albert Woltjes/a7%20rad%20stade%20nieuw1-500h.jpg"
                  className="fotos-albert-woltjes-image16"
                />
                <span className="fotos-albert-woltjes-text16">
                  In je 18e levensjaar werd elke Duitser opgeroepen voor de
                  Reichsarbeitsdienst (RAD). Albert is de tweede van links op de
                  achterste rij. De eerste maanden was hij in Assel bij Stade. 
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-lille swiper-slide"
            >
              <div className="fotos-albert-woltjes-container18">
                <img
                  alt="image"
                  src="/Albert Woltjes/a8%20rad%20lille-800w.jpg"
                  className="fotos-albert-woltjes-image17"
                />
                <span className="fotos-albert-woltjes-text17">
                  Na drie maanden opleiding in Assel, gingen ze naar Frankrijk.
                  Daar werden ze ingezet voor allerlei hand- en spandiensten,
                  zoals het voorbereiden van een terrein voor de installatie van
                  de V1.
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-inf-denemarken swiper-slide"
            >
              <div className="fotos-albert-woltjes-container19">
                <img
                  alt="image"
                  src="/Albert Woltjes/a9%20rekruut%20herning%202%20nieuw-800w.jpg"
                  className="fotos-albert-woltjes-image18"
                />
                <span className="fotos-albert-woltjes-text18">
                  Als rekruut in Denemarken. Infanterie-opleiding. Albert staat
                  rechts vooraan.
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-bombardement swiper-slide"
            >
              <div className="fotos-albert-woltjes-container20">
                <img
                  alt="image"
                  src="/Albert Woltjes/b1%20huis%20in%20puin-800w.jpg"
                  className="fotos-albert-woltjes-image19"
                />
                <span className="fotos-albert-woltjes-text19">
                  Het huis, de winkel en de bakkerij op de Hastedter Heerstrasse
                  in Bremen zijn verschillende keren beschadigd door
                  bombardementen. De ergste keer was op 20 december 1943.
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-wehrmacht swiper-slide"
            >
              <div className="fotos-albert-woltjes-container21">
                <img
                  alt="image"
                  src="/Albert Woltjes/b2%20mimizan%20wonen%20in%20wagon-800w.jpg"
                  className="fotos-albert-woltjes-image20"
                />
                <span className="fotos-albert-woltjes-text20">
                  In dienst bij de Wehrmacht in Mimizan en omgeving (Frankrijk).
                  Albert (rechts achter de ezel) woonde enige tijd in een
                  treinwagon en zorgde voor de voedselvoorziening voor de
                  soldaten
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-soldbuch swiper-slide"
            >
              <div className="fotos-albert-woltjes-container22">
                <img
                  alt="image"
                  src="/Albert Woltjes/b3%20soldbuch-800w.jpg"
                  className="fotos-albert-woltjes-image21"
                />
                <span className="fotos-albert-woltjes-text21">
                  Een pagina uit zijn soldatenboekje, dat tevens als
                  identiteitsbewijs diende.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide2fotos-rode-kruiskaart-onderduik swiper-slide"
            >
              <div className="fotos-albert-woltjes-container23">
                <div className="fotos-albert-woltjes-container24">
                  <img
                    alt="image"
                    src="/Albert Woltjes/b4%20bericht%20krijgsgevangenschap1-800w.jpg"
                    className="fotos-albert-woltjes-image22"
                  />
                  <img
                    alt="image"
                    src="/Albert Woltjes/b42%20bericht%20krijgsgevangenschap2-800w.jpg"
                    className="fotos-albert-woltjes-image23"
                  />
                </div>
                <span className="fotos-albert-woltjes-text22">
                  Via deze kaart van het Internationaal Comité van het Rode
                  Kruis (ICRC) ontvingen  Alberts ouders bericht over zijn
                  krijgsgevangenschap.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-doggy-tag-soldbuch swiper-slide"
            >
              <div className="fotos-albert-woltjes-container25">
                <img
                  alt="image"
                  src="/Albert Woltjes/b5%20doggy%20tag-800w.jpg"
                  className="fotos-albert-woltjes-image24"
                />
                <span className="fotos-albert-woltjes-text23">
                  Doggy tag en registratie van de &quot;cage&quot; waar Albert
                  in Amerikaanse gevangenschap in Cherbourg geplaatst werd. 
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-franse-gevangenschap swiper-slide"
            >
              <div className="fotos-albert-woltjes-container26">
                <img
                  alt="image"
                  src="/Albert Woltjes/b6%20frans%20gevangenenummer-800w.jpg"
                  className="fotos-albert-woltjes-image25"
                />
                <span className="fotos-albert-woltjes-text24">
                  In augustus 1945 werd hij overgedragen aan de Fransen. Hij
                  kreeg een PG-nummer (prisonnier de guerre) en werd naar
                  diverse commando&apos;s gestuurd.
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-steenfabriek swiper-slide"
            >
              <div className="fotos-albert-woltjes-container27">
                <img
                  alt="image"
                  src="/Albert Woltjes/b8%20steenfabriek-800w.jpg"
                  className="fotos-albert-woltjes-image26"
                />
                <span className="fotos-albert-woltjes-text25">
                  Drie foto&apos;s van de steenfabriek waar Albert lange tijd
                  als krijgsgevangene tewerkgesteld was, de Tuilerie
                  Saint-Parres-les-Vaudes. Albert staat op de middelste foto,
                  tweede van rechts. 
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-brieven swiper-slide"
            >
              <div className="fotos-albert-woltjes-container28">
                <img
                  alt="image"
                  src="/Albert Woltjes/b9%20brief%20samen-800w.jpeg"
                  className="fotos-albert-woltjes-image27"
                />
                <span className="fotos-albert-woltjes-text26">
                  Voor- en achterkant van een van de vele brieven die Albert (in
                  het Sütterlin) naar huis geschreven heeft. 
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-ontslagbrief swiper-slide"
            >
              <div className="fotos-albert-woltjes-container29">
                <img
                  alt="image"
                  src="/Albert Woltjes/c1%20entlassungsschein-1-800w.jpeg"
                  className="fotos-albert-woltjes-image28"
                />
                <span className="fotos-albert-woltjes-text27">
                  Ontslag krijgsgevangenschap september 1948
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-herbouw-huis swiper-slide"
            >
              <div className="fotos-albert-woltjes-container30">
                <img
                  alt="image"
                  src="/Albert Woltjes/c2%20herbouw%20huis-800w.jpg"
                  className="fotos-albert-woltjes-image29"
                />
                <span className="fotos-albert-woltjes-text28">
                  Herbouw van het door bombardementen verwoeste huis
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-woltjes-slide1foto-bakker swiper-slide"
            >
              <div className="fotos-albert-woltjes-container31">
                <img
                  alt="image"
                  src="/Albert Woltjes/c3%20bakker%20vati1-800w.jpg"
                  className="fotos-albert-woltjes-image30"
                />
                <span className="fotos-albert-woltjes-text29">
                  Werken in de bakkerij, een droom die uitkomt.
                </span>
              </div>
            </div>
          </div>
          <div
            data-thq="slider-pagination"
            className="swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal"
          >
            <div
              data-thq="slider-pagination-bullet"
              className="swiper-pagination-bullet swiper-pagination-bullet-active"
            ></div>
          </div>
          <div
            data-thq="slider-button-prev"
            className="fotos-albert-woltjes-slider-button-prev swiper-button-prev"
          ></div>
          <div
            data-thq="slider-button-next"
            className="fotos-albert-woltjes-slider-button-next swiper-button-next"
          ></div>
        </div>
      </div>
      <Footer rootClassName="footerroot-class-name29"></Footer>
    </div>
  )
}

export default FotosAlbertWoltjes
